module.exports = __webpack_public_path__ + "static/bg6.88b8485e.png";